import { EditorTemplatesCarousel } from "@/components/editor/EditorTemplatesCarousel";
import type { MyBrandKitsQuery } from "@/generated/graphql";

type BrandKit = MyBrandKitsQuery["myBrandKits"][number];

interface BrandKitScrollRowProps {
  kits: BrandKit[];
  selectedId: string;
  onSelect: (id: string) => void;
  showDefault?: boolean;
  disabled?: boolean;
}

export default function BrandKitScrollRow({
  kits,
  selectedId,
  onSelect,
  disabled,
}: BrandKitScrollRowProps) {
  return (
    <EditorTemplatesCarousel
      kits={kits}
      selectedId={selectedId}
      onSelect={onSelect}
      disabled={disabled}
    />
  );
}
